import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import {IncomeTaxPersonalChildCampOptions,} from '../../../../../../../../../../../common/src/options/calculations/income-tax/personal/common/income-tax-personal-child-camp.options';
import {IncomeTaxPersonalChildFederalInRrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/income-tax/personal/income-tax-personal-child-federal-in-rrsp.options";
import {IncomeTaxPersonalChildQuebecInRrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/income-tax/personal/income-tax-personal-child-quebec-in-rrsp.options";
import {IncomeTaxPersonalInRrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/income-tax/personal/income-tax-personal-in-rrsp.options";
import {RrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/rrsp.options";
import {IncomeTaxPersonalChildInRrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/income-tax/personal/income-tax-personal-child-in-rrsp.options";


@Component({
  selector: 'app-rrsp-personal-tax-child-form',
  templateUrl: './rrsp-personal-tax-child-form.component.html',
  styleUrls: ['./rrsp-personal-tax-child-form.component.scss'],
  standalone: false,
})
export class RrspPersonalTaxChildFormComponent {

  @Input()
  childForm: AdvancedFormGroup<IncomeTaxPersonalChildInRrspOptions>;

  @Input()
  index: number;

  @Input()
  form: AdvancedForm<RrspOptions>;

  constructor(private readonly translateService: TranslateService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  get camps(): AdvancedFormArray<IncomeTaxPersonalChildCampOptions> {
    return this.childForm.formElements.camps as AdvancedFormArray<IncomeTaxPersonalChildCampOptions>;
  }

  get federalForm(): AdvancedFormGroup<IncomeTaxPersonalChildFederalInRrspOptions> {
    return this.childForm.formElements.federal as AdvancedFormGroup<IncomeTaxPersonalChildFederalInRrspOptions>;
  }

  get quebecForm(): AdvancedFormGroup<IncomeTaxPersonalChildQuebecInRrspOptions> {
    return this.childForm.formElements.quebec as AdvancedFormGroup<IncomeTaxPersonalChildQuebecInRrspOptions>;
  }

  get incomeTaxPersonalForm(): AdvancedFormGroup<IncomeTaxPersonalInRrspOptions> {
    return this.form.formElements.personalIncomeTaxOptions as AdvancedFormGroup<IncomeTaxPersonalInRrspOptions>;
  }

  refresh() {
  }
}
